import { setActiveConversation } from "../../../features/chatSlice";
import { getConversationName, getConversationPicture } from "../../../utils/chat";
import { dateHandler } from "../../../utils/date";
import { useDispatch, useSelector } from "react-redux";
import { capitalize } from "../../../utils/string";
import { useNavigate } from "react-router-dom";

function Conversation({convo,online, typing }){

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {user}= useSelector((state)=> state.user);
    const {activeConversation} = useSelector((state)=> state.chat);
    const openConversation=async()=>{
        dispatch(setActiveConversation(convo));
        navigate('/app/inbox');
    }
    return (

        <li
        onClick={() => openConversation()}
        className={`list-none h-[72px] w-full dark:bg-dark_bg_1 hover:${
          convo._id !== activeConversation._id ? "dark:bg-dark_bg_2" : ""
        } cursor-pointer dark:text-dark_text_1 px-[10px] ${
          convo._id === activeConversation._id ? "dark:bg-dark_hover_1" : ""
        }`}
      >

                    <div className="relative w-full flex items-center justify-between py-[10px]">
                        <div className="flex items-center gap-x-3 min-w-0">

                            <div className={`relative min-w-[50px] max-w-[50px] h-[50px] rounded-full overflow-hidden ${online ? "online" : ""}`}>
                                <img src={ convo.isGroup ? convo.picture
                                    : getConversationPicture(user,convo.users)}
                                    alt={convo.name} className="w-full h-full object-cover"/>
                            </div>

                            <div className="w-full flex flex-col min-w-0">
                                <h1 className="font-bold flex items-center gap-x-2">
                                    {convo.isGroup ? convo.name
                                    : capitalize(getConversationName(user,convo.users))}
                                    {convo?.platform && (
                                        <span className="text-[10px] px-2 py-0.5 rounded-full border border-dark_border_1 dark:bg-dark_bg_2 text-dark_text_2 uppercase">
                                            {convo.platform}
                                        </span>
                                    )}
                                </h1>
                                <div>
                                    <div className="flex item-center gap-x-1 dark:text-dark_text_2 min-w-0">
                                        <div className="flex-1 items-center gap-x-1 dark:text-dark_text_2">
                                            {
                                                typing===convo._id ?
                                                <p className="text-green_1">
                                                    Typing...
                                                </p>
                                                :
                                            <p>
                                                {
                                                    convo.latestMessage?.message.length > 25 ?
                                                    `${convo.latestMessage?.message.substring(0,25)}...`
                                                    :
                                                        convo.latestMessage?.message
                                                }
                                            </p>
                                                }
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="flex flex-col items-end gap-1 text-xs">
                            {(() => {
                              const tags = convo?.tags || convo?.rawSession?.tags || [];
                              const display = tags.slice(0, 2);
                              const extra = tags.length - display.length;
                              return (
                                <div className="flex flex-wrap gap-1 justify-end">
                                  {display.map((tag) => (
                                    <span
                                      key={tag}
                                      className="text-[10px] px-2 py-0.5 rounded-full bg-green_1/15 text-green_1 border border-green_1/30"
                                    >
                                      {tag}
                                    </span>
                                  ))}
                                  {extra > 0 && (
                                    <span className="text-[10px] px-2 py-0.5 rounded-full border border-dark_border_1 dark:bg-dark_bg_2 text-dark_text_2">
                                      +{extra}
                                    </span>
                                  )}
                                </div>
                              );
                            })()}
                            <span className="dark:text-dark_text_2">
                                {
                                    convo.latestMessage?.createdAt
                                    ? dateHandler(convo.latestMessage?.createdAt)
                                    : ""
                                }
                            </span>

                        </div>
                    </div>
                    <div className="ml-16 border-b dark:border-b-dark_border_1"></div>
        </li>
    );
}

export default Conversation;
